import { textD2CSizes } from "../../elements/text-d2c/text-d2c.constants";

const focusRing =
  "rounded-xs focus-visible:outline-2 focus-visible:outline-current focus-visible:outline-offset-4 focus-visible:outline-solid";

// The navigation design sets its links in 14px at every breakpoint, which the
// responsive TextD2C paragraph sizes do not cover.
const linkSize = "text-[14px] leading-5";

// The mobile design sets its entries in 26px up to the desktop breakpoint. The
// responsive TextD2C sizes grow from `md` on, which is still mobile navigation.
const mobileEntrySize = "text-[26px] leading-8";

/**
 * Shared classes for links and buttons rendered with the unstyled D2C Button.
 * The unstyled variant removes the focus ring, so every class adds a visible
 * outline for keyboard users.
 */
export const mainNavigationClasses = {
  focusRing,
  // The underline is drawn as a bar so it can grow out of the middle instead of
  // appearing at once. `topLevelActive` keeps it out while the menu is open.
  topLevel: `${focusRing} relative font-bold font-brand uppercase ${textD2CSizes.h6} tracking-[0.03em] after:absolute after:inset-x-0 after:-bottom-1.5 after:h-0.5 after:origin-center after:scale-x-0 after:bg-current after:transition-transform after:duration-200 after:ease-out hover:after:scale-x-100 motion-reduce:after:transition-none`,
  topLevelActive: "after:scale-x-100",
  link: `${focusRing} flex justify-start whitespace-normal text-left font-brand font-normal hover:underline ${linkSize}`,
  cta: `${focusRing} flex justify-start whitespace-normal text-left font-brand font-normal underline underline-offset-2 hover:no-underline ${textD2CSizes["p-small"]}`,
  mobileEntry: `${focusRing} w-full items-center justify-between gap-4 whitespace-normal text-left font-brand font-normal ${mobileEntrySize}`,
  mobileCta: `${focusRing} flex justify-start whitespace-normal text-left font-brand font-normal underline underline-offset-4 hover:no-underline ${textD2CSizes.p}`,
} as const;

/**
 * The mobile navigation bar lives outside the menu panel so that search, cart
 * and account stay reachable while the menu is open. Both share this id to tie
 * the bar's toggle to the panel it controls.
 */
export const mobileNavigationMenuId = "main-navigation-mobile-menu";

/**
 * Height of the mobile navigation bar (65px) and the space the menu panel keeps
 * free above it (15px), both taken from the design. Action panels end right
 * above the bar instead of scrolling below it.
 */
export const mobileNavigationBarClasses = {
  height:
    "h-[calc(65px+env(safe-area-inset-bottom,0px))] pb-[env(safe-area-inset-bottom,0px)]",
  panelOffset: "pb-[calc(80px+env(safe-area-inset-bottom,0px))]",
  panelBottom: "bottom-[calc(65px+env(safe-area-inset-bottom,0px))]",
} as const;
